import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss'],
  animations: [
    trigger('modalAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-20px)' }))
      ])
    ])
  ]
})
export class MessageModalComponent implements OnInit {
  @Input() isVisible = false;
  @Output() close = new EventEmitter<void>();
  @Output() login = new EventEmitter<string>();
  @Input() isLoading = false;
  
  // isLoading = false;
  errorMessage = '';

  constructor() {}

  ngOnInit(): void {
    
  }

  loginStore(): void {
    this.login.emit();
  }

  // Método para actualizar el estado de carga desde el componente padre
  setLoading(loading: boolean): void {
    this.isLoading = loading;
  }

  // Método para mostrar un mensaje de error desde el componente padre
  setError(message: string): void {
    this.errorMessage = message;
    this.isLoading = false;
  }
}